import colors from './colors';
import fonts from './fonts';
import typos from './typos';
import devices from './devices';

export default {
  colors,
  fonts,
  typos,
  devices
};
